import React, { useState } from 'react';
import './App.css';
import Home from './components/Home';
import Booking from './components/Booking';
import Navbar from './components/Navbar';
import Material from './components/Material';
import Footer from './components/Footer';
import ConditionsOfUse from './components/ConditionsOfUse'; 
import { Routes, Route } from 'react-router-dom';

function App() {
  const [lang, setLang] = useState('en');
  const [searchQuery, setSearchQuery] = useState(''); // Global state to hold search text

  return (
    <div className="page-container">
      {/* Pass state downstream to the interactive bar */}
      <Navbar currentLang={lang} onLangChange={setLang} searchQuery={searchQuery} onSearchChange={setSearchQuery} />
      <div className="container py-5 mt-2">
        <Routes>
          <Route path="/" element={<Home currentLang={lang} />} />
          <Route path="/booking" element={<Booking currentLang={lang} />} />
          {/* Pass search state downstream to match material items */}
          <Route path="/material" element={<Material currentLang={lang} searchQuery={searchQuery} />} />
          <Route path="/conditions-of-use" element={<ConditionsOfUse currentLang={lang} />} />
        </Routes>        
      </div>
      <Footer currentLang={lang} />
    </div>
  );
}

export default App;